import { render, staticRenderFns } from "./TradeShowOverviewPage.vue?vue&type=template&id=1909aa37&scoped=true&"
import script from "./TradeShowOverviewPage.vue?vue&type=script&lang=js&"
export * from "./TradeShowOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./TradeShowOverviewPage.vue?vue&type=style&index=0&id=1909aa37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1909aa37",
  null
  
)

export default component.exports